import fingerprintJS from '@fingerprintjs/fingerprintjs'

const fpPromise = fingerprintJS.load({
  monitoring: false,
});

const fallbackFingerprint = () => {
  const randomId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  return randomId;
}

const generateFingerprint = async () => {
  const fp = await fpPromise;
  try {
    const result = await fp.get();
    return result?.visitorId || fallbackFingerprint();
  } catch (ex) {
    console.error('Error generating fingerprint:', ex);
    return fallbackFingerprint();
  }
}

export const getFingerprint = async () => {
  let fingerprint = localStorage.getItem('deviceId');

  if (!fingerprint) {
    fingerprint = await generateFingerprint();
    localStorage.setItem('deviceId', fingerprint);
  }

  return fingerprint;
}
